import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { Header } from './components/Header';
import { ConvertPage } from './pages/ConvertPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { PricingPage } from './pages/PricingPage';
import { LegalPage } from './pages/LegalPage';
import { ContactPage } from './pages/ContactPage';
import { AccountPage } from './pages/AccountPage';
import { ExcelToXliffArticle } from './pages/articles/ExcelToXliffArticle';
import { XliffToExcelArticle } from './pages/articles/XliffToExcelArticle';
import { ExcelTradosArticle } from './pages/articles/ExcelTradosArticle';
import { ExcelMemoQArticle } from './pages/articles/ExcelMemoQArticle';
import { SegmentationArticle } from './pages/articles/SegmentationArticle';
import { HtmlParsingArticle } from './pages/articles/HtmlParsingArticle';
import { MultilingualExcelArticle } from './pages/articles/MultilingualExcelArticle';
import { GoogleSheetsXliffArticle } from './pages/articles/GoogleSheetsXliffArticle';
import './styles.css';
import '@aws-amplify/ui-react/styles.css';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    }
  }
});

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <div className="app-shell">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<ConvertPage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/legal" element={<LegalPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/account" element={<AccountPage />} />

              {/* Google Sheets Import */}
              <Route path="/convert" element={<ConvertPage />} />

              {/* SEO Articles */}
              <Route path="/excel-to-xliff" element={<ExcelToXliffArticle />} />
              <Route path="/xliff-to-excel" element={<XliffToExcelArticle />} />
              <Route path="/excel-trados-workflow" element={<ExcelTradosArticle />} />
              <Route path="/excel-memoq-xliff" element={<ExcelMemoQArticle />} />
              <Route path="/segmentation-in-localization" element={<SegmentationArticle />} />
              <Route path="/html-parsing-in-excel" element={<HtmlParsingArticle />} />
              <Route path="/handling-multilingual-excel-for-translation" element={<MultilingualExcelArticle />} />
              <Route path="/google-sheets-to-xliff" element={<GoogleSheetsXliffArticle />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
